import axios, { AxiosResponse, InternalAxiosRequestConfig, CancelTokenSource, CancelToken} from 'axios';
import store from '../redux/store';
import { v4 as uuidv4 } from 'uuid';
import { ai, getAppInsights } from '../services/TelemetryService'; // Ensure AI is imported

export default class InterceptorAxios {
  static readonly telemetry = ai;
  private static source:CancelTokenSource = axios.CancelToken.source();
  private static cancelToken:CancelToken = InterceptorAxios.source.token;

  private static _correlationId: string | null = null;

  public static get correlationId(): string | null {
    return InterceptorAxios._correlationId;
  }

  public static readonly configure = () => {
    axios.interceptors.response.use(
      (response: AxiosResponse) => {
        // Any status code that lie within the range of 2xx cause this function to trigger
        // Do something with response data
        return response;
      },
      function (error) {
         // Any status codes that falls outside the range of 2xx cause this function to trigger
        // Do something with response error
        if (error.response?.status === 401) {
          const {
            config: { apiBaseUrl }
          } = store.getState();
          globalThis.window.location.replace(`${apiBaseUrl}/login`);
        }
        return Promise.reject(error);
      }
    );
    axios.interceptors.request.use(
      (request: InternalAxiosRequestConfig) => {
         // Add the CancelToken to every request
        request.cancelToken = InterceptorAxios.cancelToken;

        const { config: { baseUrl, apimKey, env } } = store.getState();
        if (request.url?.startsWith(baseUrl)) {
          request.headers['Ocp-Apim-Subscription-Key'] = apimKey;
          request.headers['Environment'] = env;
        } 
        // Generate a new correlation ID for every new request 
        InterceptorAxios._correlationId = uuidv4();
        request.headers['x-correlation-id'] = InterceptorAxios.correlationId;
        
        const appInsightsInstance = getAppInsights();
        if (appInsightsInstance) {
          appInsightsInstance.trackTrace({
            message: "Request initialized",
            severityLevel: 1,
            properties: { traceID: InterceptorAxios.correlationId },
          });
        }
        return request;
      },
      err => {
        const error = new Error(err);
        return Promise.reject(error);
      }
    );
    InterceptorAxios.configCancelToken();
  };

  public static readonly configCancelToken = () => {
    axios.interceptors.request.use(
      (request : InternalAxiosRequestConfig) => {
        request.cancelToken = InterceptorAxios.cancelToken;
        return request
      },
      err => {
        return Promise.reject(err)
      }
    );
  }
  public static readonly cancelRequest = () => {
    if(InterceptorAxios.source){
      InterceptorAxios.source.cancel('Request canceled!');
      InterceptorAxios.source = axios.CancelToken.source();
      InterceptorAxios.cancelToken = InterceptorAxios.source.token;
      InterceptorAxios.configCancelToken();
    }
  }
}
